import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Navbar from "@/components/Navbar";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/scenarios");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar minimal />
      <div className="max-w-md mx-auto px-6 pt-16 pb-24">
        <div className="text-xs tracking-[0.18em] uppercase text-stone-500 mb-3">Welcome back</div>
        <h1 className="font-display text-3xl md:text-4xl text-stone-900 tracking-tight">
          Sign in to keep practicing.
        </h1>

        <form onSubmit={handleSubmit} className="mt-10 space-y-5" data-testid="login-form">
          <div>
            <Label htmlFor="email" className="text-sm font-medium text-stone-700 mb-2 block">Email</Label>
            <Input
              id="email"
              data-testid="login-email-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-xl h-12 bg-white border-slate-200 focus-visible:ring-[#EA580C]/20 focus-visible:border-[#EA580C]"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm font-medium text-stone-700 mb-2 block">Password</Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-xl h-12 bg-white border-slate-200 focus-visible:ring-[#EA580C]/20 focus-visible:border-[#EA580C]"
            />
          </div>
          <Button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-xl bg-[#EA580C] hover:bg-[#C2410C] text-white text-base font-semibold shadow-sm shadow-orange-200"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
